"use client";

import React, { type ReactNode, useEffect } from "react";

export function ReactProvider({ children }: { children: ReactNode }) {
  useEffect(() => {
    // Garantir que o React está disponível globalmente em ambientes cliente
    if (typeof window !== "undefined") {
      window.React = React;
    }
  }, []);

  return <>{children}</>;
}
